import { defineMessages } from 'react-intl';

export default defineMessages({
  title: 'Avboka',
  confirmation: 'Är du säker på att du vill avboka?',
  cancelButton: 'Avbryt',
  confirmButton: 'Avboka',
});
